import { panic } from "@glideapps/ts-necessities";
import type { ScreenDescription } from "./description";
import { isAddClassScreenName, isEditClassScreenName, isFormScreen, MutatingScreenKind } from "./description";

export function getMutatingKindForScreen(
    screenName: string | undefined,
    description: ScreenDescription | undefined
): MutatingScreenKind | undefined {
    if (screenName === undefined || description === undefined) return undefined;
    if (isEditClassScreenName(screenName)) {
        if (isAddClassScreenName(screenName)) {
            return panic("Edit screen is also add screen?");
        } else if (isFormScreen(description)) {
            return panic("Edit screen is also form screen?");
        }
        return MutatingScreenKind.EditScreen;
    } else if (isAddClassScreenName(screenName)) {
        if (isFormScreen(description)) {
            return panic("Add screen is also form screen?");
        }
        return MutatingScreenKind.AddScreen;
    } else if (isFormScreen(description)) {
        return MutatingScreenKind.FormScreen;
    }
    return undefined;
}
